import getCentroid from '../feature/getCentroid';
import middleCoordinate from '../coordinates/middleCoordinate';

export default function getCentroidForFeatures(features) {
	return middleCoordinate(features.map(getCentroid));
}
